(($)=>{

    "use strict";

    const $resources = $('.row-resources');
    //$resources.css({opacity: 0});

	// function updateMaxHeight() {
	// 	var maxHeight = 0;
	// 	$('.poly-box', $resources).each(function(index, el) {
	// 		$(el).height();
	// 		if ( maxHeight < $(el).height() ) maxHeight = $(el).height();
	// 	});
	//
	// 	$('.poly-box', $resources).each(function(index, el) {
	// 		$(el).height( maxHeight );
	// 	});
	//
	// }
	function esrbUpdatePushers() {
		$('.section-additional_resources .poly-box .excerpt').each(function(index, el) {
			var height = $(el).height();
			var pusher = $(el).find('.pusher');
			pusher.height(height - 75);
		});
	}

    $resources.on('init breakpoint', function(event, slick, currentSlide, nextSlide) {
		esrbUpdatePushers();
		$('.poly-box', $resources).css('height','auto');
		// updateMaxHeight();
	});
	$(window).on('resize', function(){
		esrbUpdatePushers();
		$('.poly-box', $resources).css('height','auto');
		// updateMaxHeight();
	});


    $resources.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: false,
		dots: false,
		arrows: true,
		prevArrow: $('.section-additional_resources .nav .prev'),
		nextArrow: $('.section-additional_resources .nav .next'),

		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3
				}
			},
			{ breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			},
			{ breakpoint: 576,
				settings: {
					slidesToShow: 1
				}
			},
		]
	});
	esrbUpdatePushers();
    $('.poly-box', $resources).css('height','auto');
	// updateMaxHeight();


	$resources.imagesLoaded().progress( function( instance, image ) {
        $('.poly-box', $resources).css('height','auto');
        // updateMaxHeight();
    }).done(function(){
    	$resources.fadeTo(300, 1);
	});

})(jQuery);